module.exports = __webpack_public_path__ + "static/media/forkop.f508bd8d.jpg";